import { SignUp } from '@clerk/clerk-react';
import { dark } from '@clerk/themes';
import { useTheme } from '@/components/ThemeProvider/ThemeProvider';

export const Signup = () => {
  const { theme } = useTheme();

  const isDark =
    theme === 'dark' ||
    (theme === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <SignUp
        routing="path"
        path="/signup"
        signInUrl="/login"
        appearance={{
          baseTheme: isDark ? dark : undefined,
          variables: {
            colorPrimary: '#3b82f6',
            colorBackground: isDark ? '#141b2d' : '#ffffff',
          },
        }}
      />
    </div>
  );
};
